// ChangeRoleAdmin.jsx
import React, { useContext, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { UserContext } from "../../../Context/UserContext.js";



   export default function ChangeUserRoleAdmin() {
      const {userToken , getSpecificUser , user} = useContext(UserContext) ;
      const closeBtnRef = useRef() ;



      const header = {
         token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
      }


      const handleSubmit = async(values, { resetForm }) => {
         await axios.patch(`${process.env.REACT_APP_BASE_URL}/api/v1/users/role/${user._id}` , values ,  {headers:header})
         .then(({data})=>{
            if(data.message === "success"){
               toast.success("Change Role Successfully ") ;
               getSpecificUser(user._id)
            }
         })
         .catch((error)=>{
            toast.error(error.response.data.message)
         })
         resetForm();
         closeBtnRef.current.click() ;
      };


      const initialValues = {
         role: user.role || "",
      };
      const validationSchema = Yup.object({
         role: Yup.string().required("الدور   مطلوب")
      });


      return (
            <div className="ChangeRoleAdmin-container">
               <div className="modal fade" id="ChangeRoleAdmin" tabIndex="-1" aria-labelledby="ChangeRoleAdminLabel" aria-hidden="true">
                  <div className="modal-dialog">
                     <div className="modal-content">

                        <div className="modal-header">
                           <h5 className="modal-title" id="ChangeRoleAdminLabel">تغيير كلمة المرور</h5>
                           <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                        </div>

                        <div className="modal-body">
                           <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize>
                              <Form>
                                 
                                 <div className="mb-3">
                                    <label className="form-label d-block">الحالة</label>

                                    <div className="form-check form-check-inline">
                                       <Field
                                          type="radio"
                                          name="role"
                                          value="admin"
                                          className="form-check-input"
                                          id="admin"
                                       />
                                       <label htmlFor="admin" className="form-check-label">Admin</label>
                                    </div>

                                    <div className="form-check form-check-inline">
                                       <Field
                                          type="radio"
                                          name="role"
                                          value="moderator"
                                          className="form-check-input"
                                          id="moderator"
                                       />
                                       <label htmlFor="moderator" className="form-check-label">Moderator</label>
                                    </div>

                                    <div className="form-check form-check-inline">
                                       <Field
                                          type="radio"
                                          name="role"
                                          value="user"
                                          className="form-check-input"
                                          id="user"
                                       />
                                       <label htmlFor="user" className="form-check-label">User</label>
                                    </div>

                                    <div className="text-danger"><ErrorMessage name="role" /></div>
                                 </div>


                                 <div className="d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary">تغيير</button>
                                 </div>
                              </Form>
                           </Formik>
                        </div>

                     </div>
                  </div>
               </div>
            </div>
         );
   }
